import { ChevronLeft, ChevronRight } from "lucide-react";

export function Pagination({ page, pages, total, pageSize, onPage }) {
  if (!total) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(total, page * pageSize);
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t-2 border-dashed border-zinc-300 pt-4" data-testid="pagination">
      <p className="text-sm font-semibold text-zinc-600" data-testid="pagination-range">
        Showing {from}–{to} of {total}
      </p>
      <div className="flex items-center gap-2">
        <button type="button" className="btn-ghost !px-3 !py-1.5 !text-xs" onClick={() => onPage(page - 1)} disabled={page <= 1} data-testid="pagination-prev">
          <ChevronLeft className="h-4 w-4" /> Prev
        </button>
        <span className="font-mono text-sm" data-testid="pagination-page">
          {page} / {pages}
        </span>
        <button type="button" className="btn-ghost !px-3 !py-1.5 !text-xs" onClick={() => onPage(page + 1)} disabled={page >= pages} data-testid="pagination-next">
          Next <ChevronRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
